import { LoanRate } from './../../../../models/plan/loanRate';
import { PlanDetail } from './../model/plandetail';
import { Action } from '@ngrx/store';
export const SELECTPAYMENT = 'SELECT PAYMENT';
export const SELECT_CREDITCOMPANY = 'SELECT CREDITCOMPANY';
export const SELECT_PLANPAYMENT = 'SELECT PLANPAYMENT';
export const UPDATE_PLANONE = 'UPDATE PLANONE';
export const UPDATE_PLANTWO = 'UPDATE PLANTWO';
export const LOAD_PAYMENT = 'LOAD PAYMENT';
export const INIT_PLANPAYMENT = 'INIT PLANPAYMENT';
export const INIT_PLANONE = 'INIT PLANONE';
export const INIT_PLANTWO = 'INIT PLANTWO';
export const DEFAULT_BONUSMONTH = 'DEFAULT BONUSMONTH';
export const LOAD_PLANONE = 'LOAD PLANONE';
export const LOAD_PLANTWO = 'LOAD PLANTWO';
export const RESET_ERRORPAYMENTONE = 'RESET ERRORPAYMENTONE';
export const RESET_ERRORPAYMENTTWO = 'RESET ERRORPAYMENTTWO';
export const SELECT_GRADECAR = 'SELECT GRADECAR';

export class SelectPayment implements Action {
  readonly type = SELECTPAYMENT;
  constructor(public payload: number) {}
}

export class LoadPayment implements Action {
  readonly type = LOAD_PAYMENT;
  constructor(public payload: boolean) {}
}

export class SelectCreditCompany implements Action {
  readonly type = SELECT_CREDITCOMPANY;
  constructor(public payload: number) {}
}

export class SelectPlanPayment implements Action {
  readonly type = SELECT_PLANPAYMENT;
  constructor(public payload: number) {}
}

export class UpdatePlanOne implements Action {
  readonly type = UPDATE_PLANONE;
  constructor(public payload: PlanDetail) {}
}

export class UpdatePlanTwo implements Action {
  readonly type = UPDATE_PLANTWO;
  constructor(public payload: PlanDetail) {}
}

export class InitPlanPayment implements Action {
  readonly type = INIT_PLANPAYMENT;
  constructor() {}
}

export class InitPlanOne implements Action {
  readonly type = INIT_PLANONE;
  constructor() {}
}

export class InitPlanTwo implements Action {
  readonly type = INIT_PLANTWO;
  constructor() {}
}

export class DefaultBonusmonth implements Action {
  readonly type = DEFAULT_BONUSMONTH;
  constructor(public payload: any) {}
}

export class LoadPlanOne implements Action {
  readonly type = LOAD_PLANONE;
  constructor(public payload: any) {}
}

export class LoadPlanTwo implements Action {
  readonly type = LOAD_PLANTWO;
  constructor(public payload: any) {}
}

export class ResetErrorPaymentOne implements Action {
  readonly type = RESET_ERRORPAYMENTONE;
  constructor() {}
}

export class ResetErrorPaymentTwo implements Action {
  readonly type = RESET_ERRORPAYMENTTWO;
  constructor() {}
}

export class SelectgradeCar implements Action {
  readonly type = SELECT_GRADECAR;
  constructor(public payload: any) {}
}

// export class loanPlan

export type Actions =
  | SelectPayment
  | SelectCreditCompany
  | SelectPlanPayment
  | UpdatePlanOne
  | UpdatePlanTwo
  | LoadPayment
  | InitPlanPayment
  | InitPlanOne
  | InitPlanTwo
  | DefaultBonusmonth
  | LoadPlanOne
  | LoadPlanTwo
  | ResetErrorPaymentOne
  | ResetErrorPaymentTwo
  | SelectgradeCar;



// WEBPACK FOOTER //
// ./src/app/plan/payment-way/loan/actions/paymentloan.ts